import { Box, Button, Dialog, DialogActions, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import TelegramIcon from '@mui/icons-material/Telegram';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Network from "./network/Network";
import instId from "./network/instituteId";

export const Footer = () => {

  const isMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const [coursesList, setCoursesList] = useState([]);
  const [contactUsModal, setContactUsModal] = useState(false);

  console.log('contactUsModal', contactUsModal);
  

  useEffect(() => {
    getAllCourses();
  }, []);

  const getAllCourses = async () => {
    const response = await Network.fetchCourses(instId);
    const course = response?.courses;
    const filterCourses = course?.filter((item) => item?.active === true);
    setCoursesList(filterCourses);
  };

  const handleAboutUs = () => {
    navigate('/aboutUs')
  }
  const handleTermsAndCondition = () => {
    navigate('/terms-condtion')
  }

  const handleContactUsClick = () => {
    navigate("/", { state: { scrollTo: "contact" } });
  };

  const handleCaInterCourse = (item) => {
    const value = coursesList.find(course => course.title === item);
    if (value) {
      navigate('/course-content', { state: { data: value } });
    } else {
      console.error("Course not found");
    }
  }

  const handleContactUs = () => {
    console.log('fgbfvb');
    
    setContactUsModal(true)
  }

  return (
    <div>
      <div id="contact">
        <Grid container sx={{ alignItems: "center", justifyContent: "center", padding: isMobile ? "50px" : "30px" }} className="footer-first-section">
          <Grid item xs={12} sm={7} md={7} lg={7}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              <span onClick={() => handleCaInterCourse("CA Inter")} style={{ cursor: "pointer" }}> CA Inter Test Seres </span> | <span style={{ cursor: "pointer" }} onClick={() => handleCaInterCourse("CA Final")}>CA Final Test Series </span> | <span style={{ cursor: "pointer" }} onClick={() => handleCaInterCourse("CA Foundation")}>CA Foundation Test Series </span> | Audit & Ethics Test Series
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              Taxation Test Series | Law Test Series | Direct Tax (DT) Test Series | Indirect Tax  (IDT) Test Series
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 8, fontSize: "15px" }}>
              Accounts Test Series | FM & SM Test Series | Cost & Management Test Series
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              Need any help, Feel Free to reach us out :  +91 7796898989 |  examprep@vsmartacademy.com
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px", cursor: "pointer" }} onClick={handleAboutUs}>
              About Us
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px", cursor: "pointer" }} onClick={handleContactUs}>
              Contact Us
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px", cursor: "pointer" }}>
              Refund Policy
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px", cursor: "pointer" }}>
              Privacy Policy
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px", cursor: "pointer" }} onClick={handleTermsAndCondition}>
              Terms and Conditions
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} md={3} lg={3}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              Office # 62, 2nd Floor, Kumar
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              Prestige Point, Bajirao Rd,
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, fontSize: "15px" }}>
              Shukrawar Peth, Pune – 411 002
            </Typography>
            <div className="row">
              <div className="social" style={{ marginLeft: "5px" }}>
                <ul>
                  <li>
                    <a href={"https://www.facebook.com/people/FAST-Education/100092834923160/?mibextid=2JQ9oc"} target="_blank" rel="noreferrer">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={"https://www.instagram.com/vsmartexamprep/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={"https://www.youtube.com/channel/UCmtPrBlbO2REG6I_jxzkBOg"} target="_blank" rel="noreferrer">
                      <i className="fa fa-youtube"></i>
                      {/* <i className="fa fa-globe"></i> */}
                    </a>
                  </li>
                  <li>
                    <a href={"https://api.whatsapp.com/send/?phone=	7796898989&text=Hi+Team%2C+is+there+any+related+service+available+%3F&type=phone_number&app_absent=0"} target="_blank" rel="noreferrer">
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>
                  <li>
                    <a href={"https://www.linkedin.com/company/fasteducation/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href={"https://t.me/vsmartexamprep"} target="_blank" rel="noreferrer">

                      <i className="fa fa-telegram" ><TelegramIcon fontSize='large' /></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              © Copyright Vsmart ExamPrep
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid container style={{ background: 'black', textAlign: 'center', padding: "10px" }}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <p style={{ margin: 0, fontSize: "12px" }}>@ 2024 Fast Education Private Limited, All rights reserved.</p>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <p style={{ margin: 0, fontSize: "12px" }}><Link to={"/privacypolicy"} style={{color: "rgba(255, 255, 255, 0.75)"}}>Privasy Policy</Link> | Terms and Condition  |  Cancellation and Refund Policy</p>
          </Grid>
        </Grid> */}
        {/* <div className="row" style={{ background: 'black', padding: "12px", textAlign: 'center' }}>
          <div className="col-md-6">
           
          </div>
          <div className="col-md-6">
          
          </div>
        </div> */}
      </div>

      {/* <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2023 Issaaf Kattan React Land Page Template. Design by{" "}
            <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
        </div>
      </div> */}
      <Dialog open={contactUsModal} onClose={() => setContactUsModal(false)}>
        <DialogContent sx={{ flex: 1, padding: 0 }}>  {/* Remove padding and allow full height */}
          <Grid container sx={{ height: "100%" }}>
            <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%", padding: "20px" }}>
              <iframe
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "500px",
                  border: "none"
                }}
                src={`https://forms.classiolabs.com/?instituteid=${instId}`}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactUsModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
